import { HomeQuotation } from './components';

export const StepThree = () => <HomeQuotation />;